import {useRouteLoaderData} from 'react-router'
import {loader as rootLoader} from '~/root'

export const useRootLoaderData = () => {
  const loaderData = useRouteLoaderData<typeof rootLoader>('root')

  if (!loaderData) {
    throw new Error('No loader data found')
  }

  return loaderData
}
